import request from "@/utils/request";
export function translateInvoice(query) {
  return request({
    url: "/ntocc-basic-api/invoice/translateInvoice",
    method: "get",
    params: query
  });
}
// export function listByHB(query) {
//   return request({
//     url: "/ntocc-basic-api/invoice/listByHB",
//     method: "get",
//     params: query
//   });
// }
export function invoiceMessage(query) {
  return request({
    url: "/ntocc-basic-api/invoiceMessage",
    method: "get",
    params: query
  });
}
export function listByHB(query) {
  return request({
    url: "/ntocc-basic-api/invoice/listByHB",
    method: "get",
    params: query
  });
}
export function invoiceList(data) {
  return request({
    url: "/ntocc-basic-api/invoice",
    method: "get",
    params: data
  });
}

// 编辑发票备注
export function editInvoice(data) {
  return request({
    url: "/ntocc-basic-api/invoice",
    method: "put",
    data: data
  });
}

export function invoiceSimpleDetail(data) {
  return request({
    url: "/ntocc-basic-api/invoice/simpleDetail",
    method: "post",
    data: data
  });
}
export function drawInvoice(data) {
  return request({
    url: "/ntocc-basic-api/invoice/drawInvoice",
    method: "put",
    params: data
  });
}
// 索取发票
export function invoice(data) {
  return request({
    url: "/ntocc-basic-api/invoice",
    method: "post",
    data: data
  });
}
export function partyBalanceStatistics(query) {
  return request({
    url: "/ntocc-basic-api/party/partyBalanceStatistics",
    method: "get",
    params: query
  });
}
// export function shipmentBalanceStatistics(query) {
//   return request({
//     url: "/ntocc-basic-api/party/shipmentBalanceStatistics",
//     method: "get",
//     params: query
//   });
// }
// export function driverBalanceStatistics(query) {
//   return request({
//     url: "/ntocc-basic-api/party/driverBalanceStatistics",
//     method: "get",
//     params: query
//   });
// }
// 查询网商余额
export function queryBalance(code) {
  return request({
    url: `/ntocc-tms-api/mybankMerchant/queryBalance/${code}`,
    method: "get"
  });
}
export function shipmentPaidRecord(query) {
  return request({
    url: "/ntocc-basic-api/shipmentPaidRecord",
    method: "get",
    params: query
  });
}
export function submitRecharge(data) {
  return request({
    url: "/ntocc-basic-api/shipmentPaidRecord/submitRecharge",
    method: "put",
    params: data
  });
}
export function transferApply(query) {
  return request({
    url: "/ntocc-basic-api/transferApply",
    method: "get",
    params: query
  });
}
export function transferConfirm(query) {
  return request({
    url: "/ntocc-basic-api/transferApply/transferConfirm",
    method: "put",
    params: query
  });
}
export function rechargeRecord(query) {
  return request({
    url: "/ntocc-basic-api/shipmentPaidRecord",
    method: "get",
    params: query
  });
}

// 可索取发票运输单列表-托运人(金昌税务)
export function getTranslateInvoiceJinChang(query) {
  return request({
    url: `/ntocc-basic-api/invoice/translateInvoiceJinChang`,
    method: "get",
    params: query
  });
}

export function getInvoiceMessageJinChang(query) {
  return request({
    url: "/ntocc-basic-api/invoiceMessage/invoiceMessage",
    method: "get",
    params: query
  });
}
export function obtainShipperInvoiceJinChang(data) {
  return request({
    url: "/ntocc-basic-api/invoice/obtainShipperInvoice",
    method: "get",
    params: data
  });
}

// 账户充值配置显示隐藏
export function rechargeConfig(query) {
  return request({
    url: "/ntocc-basic-api/shipmentPaidRecord/rechargeConfig",
    method: "put",
    params: query
  });
}

export function repeatInvoice(data) {
  return request({
    url: "/ntocc-basic-api/invoice/repeatInvoice" + `/${data.code}`,
    method: "get"
  });
}

// 冲红
export function fastRed(data) {
  return request({
    url: "/ntocc-basic-api/invoice/fastRed" + `/${data.code}`,
    method: "get"
  });
}

// 工商确认冲红
export function confirmRed(data) {
  return request({
    url: "/ntocc-basic-api/invoice/confirmRed",
    method: "get"
  });
}

// 获取红票详情
export function queryRed(data) {
  return request({
    url: "/ntocc-basic-api/invoice/queryRed" + `/${data.code}`,
    method: "get"
  });
}
// 查询托运人账号列表： shipmentBalanceStatistics
export function shipmentBalanceStatistics(data) {
  return request({
    url: `/ntocc-basic-api/party/shipmentBalanceStatistics`,
    method: "get",
    params: data
  });
}

// 查询托运人交易记录NEW
export function queryPayListForShipment(data) {
  return request({
    url: `/ntocc-tms-api/remitDefinite/queryPayListForShipment`,
    method: "get",
    params: data
  });
}

// 查询司机账号列表： driverBalanceStatistics
export function driverBalanceStatistics(data) {
  return request({
    url: `/ntocc-basic-api/party/driverBalanceStatistics`,
    method: "get",
    params: data
  });
}

//  获取托运人账户信息
export function currentPartnerCompany(data) {
  return request({
    url: `/ntocc-basic-api/shipmentServiceFee/currentPartnerCompany`,
    method: "get",
    params: data
  });
}
